export var ActionName = {
  SUBMIT_REVIEW_FORM: 'SUBMIT_REVIEW_FORM',
  SUBMIT_RESERVATION_FORM: 'SUBMIT_RESERVATION_FORM',
  SUBMIT_CONTACT_FORM: 'SUBMIT_CONTACT_FORM',
  ANNOTATE_MENU_ITEM: 'ANNOTATE_MENU_ITEM',
  SUBMIT_SUBSCRIBE_FORM: 'SUBMIT_SUBSCRIBE_FORM',
  WEBSITE_EVENT: 'WEBSITE_EVENT',
  CREATE_ORDER: 'CREATE_ORDER',
  START_ORDER_CHECKOUT: 'START_ORDER_CHECKOUT',
  CLOSE_ORDER_CHECKOUT: 'CLOSE_ORDER_CHECKOUT',
  ACCEPT_ORDER_ADJUSTMENTS: 'ACCEPT_ORDER_ADJUSTMENTS',
  ADD_ORDER_ITEM: 'ADD_ORDER_ITEM',
  UPDATE_ORDER_ITEM: 'UPDATE_ORDER_ITEM',
  SET_ORDER_CUSTOMER: 'SET_ORDER_CUSTOMER',
  SET_ORDER_FULFILLMENT: 'SET_ORDER_FULFILLMENT',
  SET_ORDER_PAYMENT_SOURCE: 'SET_ORDER_PAYMENT_SOURCE',
  SET_ORDER_ATTRIBUTES: 'SET_ORDER_ATTRIBUTES',
  VALIDATE_ADDRESS: 'VALIDATE_SHIPPING_ADDRESS'
};
export var DEFAULT_RETRIES = 3;
export var DEFAULT_DELAY_MS = 12000;
export var DEFAULT_RETRY_TIMEOUT_MS = 10000;
export var RECAPTCHA_SCRIPT_ID = 'recaptcha-script-enterprise-v3';